<div class="container-title">
  <div *ngIf="dataConfig.icon" class="skeleton-animation" style="width: 35px; height: 35px"></div>
  <div
    class="skeleton-animation"
    style="height: 20px; width: 17%; margin-left: 10px"
  ></div>
</div>
